import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    defaultWhite: {
      main: '#FFFFFF',
    },
    primaryLight: {
      main: '#E9F2FE',
    },
    primary: {
      main: '#0CBDD4',
    },
    divider: '#5256621A',
    text: {
      primary: '#002145D9',
      secondary: '#00214580',
    },
    secondary: {
      main: '#00214580',
    },
    info: {
      main: '#227bef1a',
    },
    error: {
      main: '#ED6868',
    },
    warning: {
      main: '#f2c94c',
    },
    appGreen: {
      main: '#20c21d',
    },
    darkBlue: {
      main: '#266071',
    },
    mediumBlue: {
      main: '#81B5CA',
    },
    lightBlue: {
      main: '#D9E9ED',
    },
    appGray: {
      main: '#00214580',
    },
    appGray2: {
      main: '#52566299',
    },
    appPurple: {
      main: '#96b1f4',
    },
    appMerino: {
      main: '#FBF9F4',
    },
    appOrange: {
      main: '#F19D60',
    },
    appPampas: {
      main: '#F0EDE6',
    },
    border: {
      main: '#5256621a',
    },
    textFlorence: {
      main: '#00214566',
    },
    textFlorenceSecondary: {
      main: '#002145B2',
    },
    paleOrange: {
      main: '#F19D601A',
    },
    translucentPrimary: {
      main: '#227BEF4D',
    },
  },
  typography: {
    subtitle: {
      fontSize: '18px',
    },
    fontFamily: [
      'SFProDisplay-Medium',
      'SFProDisplay-Regular',
      'SFProDisplay-Semibold',
      'SFProDisplay-Bold',
      'sans-serif',
    ].join(','),
    button: {
      textTransform: 'none',
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          height: '85px',
          justifyContent: 'center',
          borderBottomWidth: '1px',
          borderBottomStyle: 'solid',
          borderBottomColor: '#5256621A',
          paddingRight: '40px',
          paddingLeft: '40px',
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          overflow: 'auto',
          height: '100%',
        },
      },
    },
    MuiTableSortLabel: {
      styleOverrides: {
        root: {
          color: '#00214580',
          '&.Mui-active': {
            color: '#00214580',
          },
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          height: '56px',
        },
      },
    },
  },
});
